import { render } from "./Footer.vue?vue&type=template&id=60d2eeae&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=60d2eeae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d2eeae"]])

export default __exports__